export function invariant(
  condition: unknown,
  format: string,
): asserts condition {
  if (!condition) {
    const error = new Error(format);
    error.name = 'Invariant Violation';
    throw error;
  }
}
